import React from 'react'
import { formatFileSize, getFileExt } from '../utils/utils';
import { CrossIcon, fileIcons } from '../Icons';


const SelectedFileCard = ({ file, removeFile, indexToRemove }) => {
    const ext = getFileExt(file?.name);
    const FileIcon = fileIcons?.[ext]
    return (
        <div key={file?.name + indexToRemove} className='shadow-[0px_4px_25px_0px_#0000000D] flex items-center gap-2 bg-[#ffffff] border border-[#E7E7E7] p-2 rounded-md'>
            {FileIcon && <FileIcon />}
            <div className='flex flex-col justify-center min-w-0 flex-1'>
                <span className='truncate text-[#232323] font-normal text-[0.7rem] '>{file?.name}</span>
                <span className="text-[#808080] font-normal text-[0.7rem]">{formatFileSize(file?.size)}</span>
            </div>
            <button onClick={() => {removeFile(indexToRemove)}}  className="p-0 m-0 bg-transparent border-0 leading-none text-inherit w-fit h-fit cursor-pointer">
                <CrossIcon w='11' h='11' />
            </button>
        </div>
    )
}

export default SelectedFileCard